$.fn.modal.Constructor.prototype.enforceFocus = function() {};

var auth = require('./extrax2-webadmin.auth.js');
var validator = require('./extrax2-webadmin.validator.js');
var datatable = require('./extrax2-webadmin.datatable.js');
var events = require('./extrax2-webadmin.events.js');
var utils = require('./extrax2-webadmin.utils.js');

(function ($) {
	var originalVal = $.fn.val;
	$.fn.val = function(value) {
		if (arguments.length >= 1 && !$(this).hasClass('datepicker')) {
			if (value === '') {
				$(this).removeClass('edited');
			} else {
				$(this).addClass('edited');
			}
		}
		return originalVal.apply(this, arguments);
	};
})(jQuery);

auth.registerAuthEvents();
events.registerCommonEvents();
validator.validatorMethods();
datatable.dataTableMethods();
utils.setFormatValues($('.page-header-top'));
